import React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
import classNames from 'classnames';

import { APP_POLLS } from 'app/common/constants/services';
import SimpleDropDown from './SimpleDropDown';
import { getIsMember } from '../../../selectors/user';
import { getIsAppPollsConnected } from '../../../selectors/applications';
import Nope from '../../common/Nope';
import styles from './FundApp.scss';

// const propTypes = {
//   children: React.PropTypes.element.isRequired,
//   schools: React.PropTypes.shape({
//     keys: React.PropTypes.array.isRequired,
//     data: React.PropTypes.object.isRequired,
//   }),
//   params: React.PropTypes.shape({
//     schoolId: React.PropTypes.string.isRequired,
//     type: React.PropTypes.string,
//     pollId: React.PropTypes.string,
//   }),
//   location: React.PropTypes.shape({
//     pathname: React.PropTypes.string.isRequired,
//   }),
//   isMember: React.PropTypes.bool.isRequired,
//   isOwnedPolls: React.PropTypes.bool.isRequired,
//   isSchoolSubscribed: React.PropTypes.bool.isRequired,
//   project_name: React.PropTypes.string.isRequired,
// };

const defaultProps = {
  params: {
    schoolId: '0',
    type: APP_POLLS,
  },
};

class FundApp extends React.Component {
  // $FlowFixMe
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { params: { type }, location: { pathname }, isMember, isOwnedPolls } = nextProps;
    // при переключении школ, если нет членства и своих голосований,
    // раздел "мои опросы" редиректится в "опросы"
    if ((type === 'mypolls') && !isMember && !isOwnedPolls) {
      let url = pathname.split('/').slice(0, 4);
      url = url.join('/');
      browserHistory.replace(`${url}/polls`);
    }
  }

  render() {
    const {
      children,
      schools,
      location: { pathname },
      params: { schoolId },
      isMember,
      isOwnedPolls,
      isSchoolSubscribed,
      project_name,
    } = this.props;
    const numId = parseInt(schoolId, 10) || 0;
    const schoolName = !!schools.keys.length
      && <SimpleDropDown items={schools} style={{ display: 'inline' }} current={numId} path={pathname} />;
    let url = pathname.split('/').slice(0, 4);
    url[2] = schoolId;
    url = url.join('/');
    const menu = (
      <div className={classNames(styles.menu, 'app-menu')}>
        <Link to={`${url}/polls`} className="app-menu__link" activeClassName="app-menu__link_active">Опросы</Link>
        {(isMember || isOwnedPolls)
          && <Link to={`${url}/mypolls`} className="app-menu__link" activeClassName="app-menu__link_active">Мои опросы</Link>}
        {/* <Link to={`${url}/bills`} className="app-menu__link" activeClassName="app-menu__link_active">Счета</Link> */}
      </div>
    );

    return (
      <div>{/* div для меньшей высоты блока, при небольшом контенте */}
        <Helmet>
          <title>{`Опросник - ${project_name}`}</title>
        </Helmet>
        <div className={styles.root}>
          <div className={styles.h1}>Опросы {schoolName}</div>
          {isSchoolSubscribed && menu}
          {isSchoolSubscribed ? children : <Nope text="Данная школа не подписана на «Электронный опросник»" />}
        </div>
      </div>
    );
  }
}

// FundApp.propTypes = propTypes;
FundApp.defaultProps = defaultProps;

const mapStateToProps = (store, ownProps) => {
  const { params: { schoolId } } = ownProps;
  const nSchoolId = parseInt(schoolId, 10);
  return ({
    isMember: getIsMember(store, nSchoolId), // член родительского комитета
    schools: store.schools,
    isOwnedPolls: store.fund.polls.hasOwn || false,
    isSchoolSubscribed: getIsAppPollsConnected(store, { id: nSchoolId }),
    project_name: store.dealer.project_name,
  });
};

export default connect(mapStateToProps)(FundApp);
